import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { useImpersonation } from "@/context/ImpersonationContext";
import { canManageAgencyUsers } from "@/lib/roles";

export function useCompanyAccess() {
  const { user } = useAuth();
  const { impersonation } = useImpersonation();

  const effectiveRole = impersonation.active ? impersonation.targetRole : user?.role;

  const hasCompanyAccess = useMemo(() => {
    const roleEligible = canManageAgencyUsers(effectiveRole);
    if (impersonation.active) return roleEligible;
    return roleEligible && !!user?.teamId && (user?.teamMemberCount ?? 0) > 1;
  }, [impersonation.active, effectiveRole, user?.teamId, user?.teamMemberCount]);

  return { effectiveRole, hasCompanyAccess };
}
